var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.data.tables),function(item,index){return _c('v-card',{key:index,attrs:{"flat":"","outlined":""}},[_c('v-card-title',[_vm._v(_vm._s(item.title)+" ")]),_c('v-card-text',[_c('data-table',{attrs:{"data":item}})],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }